import { TutorInfo, UserInfo } from '../../ts';

export const convertUserToTutor = (user: UserInfo): TutorInfo => {
  const value: TutorInfo = {
    id: user.id,
    tutorCountryId: user.tutorCountryId,
    email: user.email,
    tutorFullName: user.tutorFullName,
    phone: user.phone,
  };
  return value;
};
